import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatTextdirectionLToRIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_textdirection_l_to_r"}/>
}
